import React from 'react';
import { Button } from '../components/ui/button';
import { Robot } from '@phosphor-icons/react';

/**
 * Floating Copilot button - appears on bottom-right of authenticated pages
 */
export const CopilotButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      className="fixed bottom-6 right-6 h-14 w-14 rounded-full bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-200"
      style={{ zIndex: 9999 }}
      data-testid="copilot-btn"
    >
      <Robot size={28} weight="fill" className="text-white" />
    </Button>
  );
};

export default CopilotButton;
